module.exports = __webpack_public_path__ + "img/p5.25ddf178.png";